/* lib/PostcodeLookup/Select.svelte generated by Svelte v3.24.0 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	destroy_each,
	detach_dev,
	dispatch_dev,
	element,
	empty,
	init,
	insert_dev,
	listen_dev,
	noop,
	prevent_default,
	prop_dev,
	safe_not_equal,
	set_data_dev,
	space,
	stop_propagation,
	text,
	validate_each_argument,
	validate_slots
} from "svelte/internal";

const file = "lib/PostcodeLookup/Select.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[4] = list[i][0];
	child_ctx[5] = list[i][1];
	return child_ctx;
}

// (19:4) {:else}
function create_else_block(ctx) {
	let option;

	const block = {
		c: function create() {
			option = element("option");
			option.textContent = "No addresses found";
			option.__value = "No addresses found";
			option.value = option.__value;
			add_location(option, file, 19, 6, 642);
		},
		m: function mount(target, anchor) {
			insert_dev(target, option, anchor);
		},
		p: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(option);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_else_block.name,
		type: "else",
		source: "(19:4) {:else}",
		ctx
	});

	return block;
}

// (14:4) {#if addresses && addresses.length > 0}
function create_if_block(ctx) {
	let option;
	let each_1_anchor;
	let each_value = /*addresses*/ ctx[0];
	validate_each_argument(each_value);
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	const block = {
		c: function create() {
			option = element("option");
			option.textContent = "Choose address...";

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			each_1_anchor = empty();
			option.selected = true;
			option.disabled = true;
			option.__value = "Choose address...";
			option.value = option.__value;
			add_location(option, file, 14, 6, 470);
		},
		m: function mount(target, anchor) {
			insert_dev(target, option, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(target, anchor);
			}

			insert_dev(target, each_1_anchor, anchor);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*addresses*/ 1) {
				each_value = /*addresses*/ ctx[0];
				validate_each_argument(each_value);
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(option);
			destroy_each(each_blocks, detaching);
			if (detaching) detach_dev(each_1_anchor);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_if_block.name,
		type: "if",
		source: "(14:4) {#if addresses && addresses.length > 0}",
		ctx
	});

	return block;
}

// (16:6) {#each addresses as [value, text]}
function create_each_block(ctx) {
	let option;
	let t_value = /*text*/ ctx[5] + "";
	let t;
	let option_value_value;

	const block = {
		c: function create() {
			option = element("option");
			t = text(t_value);
			option.__value = option_value_value = /*value*/ ctx[4];
			option.value = option.__value;
			add_location(option, file, 16, 8, 572);
		},
		m: function mount(target, anchor) {
			insert_dev(target, option, anchor);
			append_dev(option, t);
		},
		p: function update(ctx, dirty) {
			if (dirty & /*addresses*/ 1 && t_value !== (t_value = /*text*/ ctx[5] + "")) set_data_dev(t, t_value);

			if (dirty & /*addresses*/ 1 && option_value_value !== (option_value_value = /*value*/ ctx[4])) {
				prop_dev(option, "__value", option_value_value);
				option.value = option.__value;
			}
		},
		d: function destroy(detaching) {
			if (detaching) detach_dev(option);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_each_block.name,
		type: "each",
		source: "(16:6) {#each addresses as [value, text]}",
		ctx
	});

	return block;
}

function create_fragment(ctx) {
	let div;
	let label;
	let t0;
	let label_class_value;
	let t1;
	let select;
	let select_class_value;
	let div_class_value;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*addresses*/ ctx[0] && /*addresses*/ ctx[0].length > 0) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	const block = {
		c: function create() {
			div = element("div");
			label = element("label");
			t0 = text("Select your address");
			t1 = space();
			select = element("select");
			if_block.c();
			attr_dev(label, "class", label_class_value = /*classNames*/ ctx[1].label);
			attr_dev(label, "for", "select-address");
			add_location(label, file, 11, 2, 230);
			attr_dev(select, "class", select_class_value = /*classNames*/ ctx[1].select);
			attr_dev(select, "id", "select-address");
			add_location(select, file, 12, 2, 313);
			attr_dev(div, "data-testid", "container");
			attr_dev(div, "class", div_class_value = /*classNames*/ ctx[1].container);
			add_location(div, file, 10, 0, 169);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, div, anchor);
			append_dev(div, label);
			append_dev(label, t0);
			append_dev(div, t1);
			append_dev(div, select);
			if_block.m(select, null);

			if (!mounted) {
				dispose = listen_dev(select, "change", stop_propagation(prevent_default(/*onChange*/ ctx[2])), false, true, true);
				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*classNames*/ 2 && label_class_value !== (label_class_value = /*classNames*/ ctx[1].label)) {
				attr_dev(label, "class", label_class_value);
			}

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(select, null);
				}
			}

			if (dirty & /*classNames*/ 2 && select_class_value !== (select_class_value = /*classNames*/ ctx[1].select)) {
				attr_dev(select, "class", select_class_value);
			}

			if (dirty & /*classNames*/ 2 && div_class_value !== (div_class_value = /*classNames*/ ctx[1].container)) {
				attr_dev(div, "class", div_class_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(div);
			if_block.d();
			mounted = false;
			dispose();
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let { addresses } = $$props;
	let { classNames = {} } = $$props;
	let { onSelected = () => null } = $$props;
	const onChange = e => onSelected(e.target.value);
	const writable_props = ["addresses", "classNames", "onSelected"];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== "$$") console.warn(`<Select> was created with unknown prop '${key}'`);
	});

	let { $$slots = {}, $$scope } = $$props;
	validate_slots("Select", $$slots, []);

	$$self.$set = $$props => {
		if ("addresses" in $$props) $$invalidate(0, addresses = $$props.addresses);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onSelected" in $$props) $$invalidate(3, onSelected = $$props.onSelected);
	};

	$$self.$capture_state = () => ({
		addresses,
		classNames,
		onSelected,
		onChange
	});

	$$self.$inject_state = $$props => {
		if ("addresses" in $$props) $$invalidate(0, addresses = $$props.addresses);
		if ("classNames" in $$props) $$invalidate(1, classNames = $$props.classNames);
		if ("onSelected" in $$props) $$invalidate(3, onSelected = $$props.onSelected);
	};

	if ($$props && "$$inject" in $$props) {
		$$self.$inject_state($$props.$$inject);
	}

	return [addresses, classNames, onChange, onSelected];
}

class Select extends SvelteComponentDev {
	constructor(options) {
		super(options);

		init(this, options, instance, create_fragment, safe_not_equal, {
			addresses: 0,
			classNames: 1,
			onSelected: 3
		});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "Select",
			options,
			id: create_fragment.name
		});

		const { ctx } = this.$$;
		const props = options.props || {};

		if (/*addresses*/ ctx[0] === undefined && !("addresses" in props)) {
			console.warn("<Select> was created without expected prop 'addresses'");
		}
	}

	get addresses() {
		throw new Error("<Select>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set addresses(value) {
		throw new Error("<Select>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get classNames() {
		throw new Error("<Select>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set classNames(value) {
		throw new Error("<Select>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	get onSelected() {
		throw new Error("<Select>: Props cannot be read directly from the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}

	set onSelected(value) {
		throw new Error("<Select>: Props cannot be set directly on the component instance unless compiling with 'accessors: true' or '<svelte:options accessors/>'");
	}
}

export default Select;